import { render, staticRenderFns } from "./Lgx241884626186928128.vue?vue&type=template&id=3bd7608e&"
import script from "./Lgx241884626186928128.vue?vue&type=script&lang=js&"
export * from "./Lgx241884626186928128.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports